<!-- 登录后的欢迎少侠，更换账号组件 -->
<template>
  <div class="role p-10" v-if="login_status">
    <div class="empty"></div>
    <div class="f-row">
      少侠&nbsp;<span class="role_name">{{ role_name }}</span>
      <ItemContainer v-if="init_data.act_data.is_reflow" class="t-white t-center huigui t-no-wrap" src="huigui-bg">回归玩家
      </ItemContainer>
      <span class="change" v-click="{ btn_name: '登录' }" @click="handle_switch">&nbsp;更换账号</span>
      <!-- <span class="change" v-click="{ btn_name: '登录' }" @click="after_login">&nbsp;预约</span> -->
    </div>
    <!-- <span
        class="change"
        v-click="{ btn_name: '换绑角色' }"
        @click="loadBindRole"
        >&nbsp;换绑角色</span
      > -->
    <!-- <div class="current-role">
      当前角色:<span>{{ roles_info.name }}</span> -
      <span>{{ roles_info.server }}</span>
    </div> -->
  </div>
  <div class="role" v-else>
    <div class="empty"></div>
    <div>
      欢迎少侠,请先&nbsp;<span class="change" v-click="{ btn_name: '登录' }" @click="login">登录账号</span>
    </div>
  </div>
  <nut-popup v-model:visible="dialog.choose" :duration="0.1" three-dimensional position="bottom" :lock-scroll="true"
    :close-on-click-overlay="false" :closeable="false">
    <nut-picker v-model="choose_server" :columns="roles" cancelText=" " title="请选择绑定角色" @confirm="confirm" />
  </nut-popup>
</template>
<script setup>
import { computed, onMounted, reactive, ref, toRaw } from 'vue';
import eventEmitter from '@utils/event';
import useLogin from '../hooks/useLogin';
import { reg_wx_share } from '@/plugins/vue/useWx';
import changeUrlParams from '@utils/changeUrlParams';
import { shareConfig } from '../pages/constant';

import {
  tx3_get_roles,
  init,
  bind_role,
  get_share_info,
  appoint,
} from '@utils/api';
import { firstLog, loginSuccessLog, bindRoleSuccessLog } from '../utils/log';
const { tx3Login } = useLogin();
const { share_id } = inject('GlobalStore');
const {
  init_data,
  set_init_data,
  login_status,
  set_login_status,
  set_error_codemsg,
  set_copy_link,
  error_codemsg,
  team_share_data,
} = inject('GlobalData');

const emits = defineEmits(['refreshTaskList']);
const role_name = computed(() => {
  if (init_data.account_data) {
    return init_data.account_data.username;
  } else {
    return '';
  }
});
const dialog = reactive({
  choose: false,
});
function login() {
  before_login();
  if (ds.isGodlike) {
    ds.callHandler('checkLogined').then(function (data) {
      if (data.code == 200) {
        if (data.result.isLogined == true) {
          ds.callHandler('getLoginedAccount').then(function (data) {
            if (data.code == 200 && ['mail'].includes(data.result.type)) {
              dsLogin();
            } else {
              tx3Login(loginSuccess);
            }
          });
        } else {
          ds.callHandler('openLoginPage');
        }
      }
    });
  } else {
    tx3Login(loginSuccess);
  }
}

// 登录成功的回调
async function loginSuccess(res) {
  console.log('登录回调函数', res);
  if (res == true) {
    await initAction();
    await after_login();
  } else {
    // eventEmitter.emit('toast', {
    //   text: '取消登录',
    //   duration: 2,
    // });
  }
}

async function initAction(callback) {
  set_error_codemsg('');
  const res = await init();
  const teamShareData = toRaw(team_share_data.value);
  if (res.code == 1) {
    set_login_status(true);
    set_init_data(res.data);
    firstLog(true);
    console.log('正确初始化', { teamShareData });
    console.log('自己team_id', res.data.act_data.team_id);
    if (!!teamShareData.id && teamShareData.id !== res.data.id) {
      console.log('已登录-分享队伍进入-分享人的id不是自己');
      if (!res.data.act_data.team_id) {
        console.log('自己无队伍', teamShareData);
        eventEmitter.emit('showJoinTeamModal');
      } else {
        console.log('自己有队伍');
        if (!!teamShareData.team_id) {
          if (teamShareData.team_id === res.data.act_data.team_id) {
            console.log('是自己的队伍', teamShareData);
          } else {
            console.log('不是自己的队伍', teamShareData);
            eventEmitter.emit('showJoinTeamModal');
          }
        }
      }
      // eventEmitter.emit('showJoinTeamModal');
    } else {
      eventEmitter.emit('closeJoinTeamModal');
      console.log('已登录-自己分享的队伍 或者 不是从分享进入', teamShareData);
    }
    callback && callback();
    regsnsShare();
  } else {
    // 这三种类型是没登录的情况，不会弹提示，是正常的，其余都是不正常的，需要弹提示告诉用户
    if (![40, 41, 42].includes(res.code)) {
      eventEmitter.emit('toast', {
        text: res.errorMsg,
      });
    }
    if (res.code === 23 || res.code === 20) {
      set_error_codemsg(res.errorMsg);
    }
    set_login_status(false);
    if (!!teamShareData.id) {
      console.log('未登录-分享队伍进入', teamShareData);
      eventEmitter.emit('showJoinTeamModal');
    }
    regsnsShare();
    firstLog(false);
  }
}

async function updateInitAction() {
  set_error_codemsg('');
  const res = await init();
  if (res.code === 23 || res.code === 20) {
    // 23: 活动未开始 20：活动已结束
    eventEmitter.emit('toast', {
      text: res.errorMsg,
    });
    set_error_codemsg(res.errorMsg);
  }
  if (res.code === 40) {
    // 未绑定账号
    set_login_status(false);
  }

  if (res.code == 1) {
    set_login_status(true);
    set_init_data(res.data);
  }
}

function before_login() {
  setTimeout(() => {
    set_init_data();
  }, 1000);
  // 做一个延迟触发，先让日志发送
  console.log('开始登录');
}

async function after_login() {
  console.log('after_login--->');
  // 先判断有没有share_id
  loginSuccessLog(init_data.account_data.username);
  if (share_id.value) {
    if (share_id.value === init_data.id) {
      if (init_data.act_data.is_appointed == false) {
        // await appoint();
        // eventEmitter.emit('showHongbaoModal');
        await initAction();
      }
    } else {
      if (init_data.act_data.is_appointed == false) {
        // await appoint({ share_id: share_id.value });
        // eventEmitter.emit('showHongbaoModal');
      }
      await initAction();
    }
  } else {
    if (init_data.act_data.is_appointed == false) {
      // await appoint();
      // eventEmitter.emit('showHongbaoModal');
      await initAction();
    }
  }
}

async function after_init() {
  console.log('after_init--->');
  // 检查是否有属于
  if (!init_data.share_id_list.includes(share_id.value)) {
    const data = await get_share_info({ share_id: share_id.value });
    if (data.code == 1) {
      // 这里跳转对应的页面
      if (data.data.share_type == 1) {
        update_share_info(data.data);
        eventEmitter.emit('account', false);
        eventEmitter.emit('go', 'meiri');
      } else {
        update_share_info(data.data);
        eventEmitter.emit('account', false);
        eventEmitter.emit('go', 'zhekou');
      }
    }
  }
}

function regsnsShare(params = {}, shareObj = {}) {
  // const user_id = init_data.id
  changeUrlParams(null, [
    'code',
    'auth_code',
    'share_id',
    'invite_id',
    'together_id',
    'isMofang',
    'status',
    'item_id',
  ]);
  const defaultParams = !!params.invite_id
    ? params
    : { share_id: init_data.id };
  const copyLink = window.location.href;
  set_copy_link(copyLink);
  changeUrlParams({ ...defaultParams, ...params }, ['code', 'auth_code']); // 默认携带share_id(除了组队的时候，因为share_id = invite_id)
  const share_link = window.location.href;
  console.log('share_link', { share_link, copyLink });
  reg_wx_share({
    ...shareConfig(),
    ...shareObj,
    url: share_link,
  });
}

async function loadBindRole() {
  console.log('拉起登录绑定页面');
  const data = await tx3_get_roles();
  if (data.code == 1) {
    if (data.data.roles.length == 0) {
      eventEmitter.emit('toast', {
        text: '该账号没有角色，请更换角色尝试',
        duration: 2,
      });
      return false;
    } else {
      change_role(data.data.roles);
    }
  } else {
    eventEmitter.emit('toast', {
      text: '拉取角色失败',
    });
  }
}

function genRedirectUrl(authUrl, h5Project, h5Activity, h5Url) {
  const url = new URL(authUrl);
  const params = new URLSearchParams(url.search);
  params.set('project', h5Project);
  params.set('activity', h5Activity);
  params.set('redirect_url', h5Url);
  url.search = params.toString();
  return url.toString();
}

function dsLogin() {
  const h5Project = 'tx3';
  const h5Activity = 'txwx';
  const h5Url = '';
  let redirect_url = undefined;
  if (import.meta.env.VITE_ENV === 'production') {
    redirect_url = `${window.location.origin}/h5hd/tx3/auth/godlike/login/redirect`;
  } else {
    redirect_url = `${window.location.origin}/h5/tx3/auth/godlike/login/redirect`;
  }
  const redirectUrl = genRedirectUrl(
    redirect_url,
    h5Project,
    h5Activity,
    h5Url || window.location.href
  );
  ds.callHandler('authorizeTrustingPage', {
    redirectUrl: redirectUrl,
  }).then(function (data) {
    ds.callHandler('showToast', {
      content: '大神授权登录失败',
    });
  });
}

onMounted(() => {
  eventEmitter.on('init', (callback) => {
    initAction(callback);
  });
  eventEmitter.on('refresh_init_bus', () => {
    // 普通刷新数据
    updateInitAction();
  });
  eventEmitter.on('login', () => {
    login();
  });
  eventEmitter.on('regsnsShareBus', (param = {}, shareObj = {}) => {
    console.log('响应分享', { param, shareObj });
    regsnsShare(param, shareObj);
  });
});

const roles = ref();
const choose_server = ref();
function change_role(data) {
  let res = [];
  data.map((e) => {
    res.push({
      text: `【${e.server_name}】- ${e.role_name}`,
      value: `${e.server_id}|${e.role_id}`,
    });
  });
  roles.value = res;
  dialog.choose = true;
}

async function confirm() {
  let res = [];
  if (choose_server.value == undefined) {
    res = roles.value[0].value.split('|');
  } else {
    res = choose_server.value[0].split('|');
  }

  let data = await bind_role({ server_id: res[0], role_id: res[1] });
  if (data.code == 1) {
    // 绑定成功
    await initAction();
    bindRoleSuccessLog();
    dialog.choose = false;
  } else {
    eventEmitter.emit('toast', {
      text: '绑定失败，请重试！',
      duration: 2,
    });
  }
}

function handle_switch() {
  if (ds.isGodlike) {
    ds.callHandler('openLoginPage').then((res) => {
      console.log(res)
    })
  }
  else {
    login()
  }
}
</script>
<style scoped>
.role {
  color: white;
  font-size: 22px;
  font-weight: bold;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.role_name {
  color: #fffa69;
}

.change {
  color: #27ff13;
  text-decoration: underline;
}

.current-role {
  color: #a99a7a;
}

.empty {
  width: 50px;
  height: 50px;
}
</style>
